import React from "react";
import styled from "styled-components";

import { down, spacings, colors } from "~/src/config/vars";

import { FooterTop, FooterBottom } from "~/src/components/footer";

const Footer = () => {
    return (
        <SFooter>
            <FooterTop />
            <FooterBottom />
        </SFooter>
    );
};

const SFooter = styled.footer`
    margin: ${spacings?.offset_80} 0 0;
    padding: ${spacings?.offset_80} 0 0;
    background-color: ${colors?.black};
    color: ${colors?.beige_base};
    ${down("md")} {
    }
`;
export default Footer;
